module.exports = __webpack_public_path__ + "static/Noori-26797e12ea0fe4a237bad2bf7e9c80c1.png";